/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React from "react";
import { Icon, Popup } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import moment from "moment";
//import { get } from "lodash";
//import { findUtcOffsetHours, findUtcOffsetMins, modesOfTransport } from "../../../util";
import "react-datepicker/dist/react-datepicker.css";
//import Images from '../config/images';

export const modesOfTransport = {
  OCEAN: "OCEAN",
  AIR: "AIR",
  TRUCK: "TRUCK",
  RAIL: "RAIL",
};

const findUtcOffsetHours = (timezone) => {
  if (!timezone) return 0;
  let s = timezone.substr(3); // Get rid of UTC, s= "+05:00"
  let sign = s[0]; // "+""
  let x = parseInt(s.substr(1, 2));
  if (isNaN(x)) return null; //if timezone is formatted incorrectly, return null
  if (sign === "-") return 0 - x;
  else return x;
};

const findUtcOffsetMins = (timezone) => {
  if (!timezone) return 0;
  let s = timezone.substr(3); // Get rid of UTC, s= "+05:00"
  //let sign = s[0]; // "+""
  let x = parseInt(s.substr(4, 5));
  if (isNaN(x)) return null; //if timezone is formatted incorrectly, return null
  return x;
};

const errorPopup = errors => {
  const error = errors.map((info, index) => {
    return (
      <div className='error' key={index}>
        * {info}
      </div>
    )
  })
  return (
    <Popup trigger={<Icon name='warning sign' size='small' color='red' />} content={error || ''} />
  )
}

const KNDatePicker = ({ errors, dateFormat, setUTCTime, updateValue, label, name, id, selected, timezone, isDisabled, mixPanelMouseDown, mixPanelMouseEnter, mixPanelMouseLeave, handleInputChange, setTransactionInputQueue, modeoftransport, timeDisabled, isClearable,isFiveColumn=true}) => {
  let redBgColor;
  if(errors && errors.length>0){
    redBgColor = "redBgColor"
  }
  return (
    <div 
    // className={`five wide field sematic-date-field ${redBgColor}`}
    className={`${isFiveColumn ? 'five' : 'eight'} wide field sematic-date-field ${redBgColor}`}
    >
      <label className="name-label" style={{
            "position": "absolute",
            "zIndex": "9",
            "marginLeft": "4px",
            "textTransform": "uppercase",
            "textOverflow":"ellipsis" }} title={label}>
          {errors && errors.length>0 && errorPopup(errors)}
          {label}
        </label>
      <DatePicker 
        name={name}
        id={id}
        selected={selected}
        onChange={(value) => {
          let date = new Date(value);
          let utc = null;
          if (!timezone || timezone === '_BLANK_') {
            // let hr = date.getUTCHours();
            // let min =date.getUTCMinutes();
            utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 12, 0, date.getUTCSeconds());
            console.log("utc ===", utc);
          } else {
            if (timezone.includes("/") || timezone =='UTC') {
              let year = date.getFullYear();
              let month = date.getMonth() + 1;
              let day = date.getDate();
              let hours = 12; //date.getHours();
              let minutes = 0; //date.getMinutes();
              let fullDateString = `${year}-${month}-${day} ${hours}:${minutes}`;
              let momentDate = moment(fullDateString);
              console.log("momentDate ==== ", momentDate);
              utc = moment.tz(momentDate.format("YYYY-MM-DDTHH:mm:ss"), timezone).format("x");
            } else {
              utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12 - findUtcOffsetHours(timezone), 0 - findUtcOffsetMins(timezone), date.getSeconds());
            }
          }
          let event = {
            target: {
              name: id,
              value: !value ? "" : id === "exportDate" ? value.getTime() : utc,
            },
          };
          handleInputChange(event);
          //setTransactionInputQueue({ type: id, value: get(event, "target.value", "") });
          //if (updateValue) updateValue(get(event, "target.value", ""));
          //if (utc) setUTCTime({ name, value: utc });
        }}
        showTimeSelect={!modeoftransport.includes('MULTIMODAL') && !modeoftransport.includes('HIGHWAY') && !modeoftransport.includes(modesOfTransport.TRUCK) && !modeoftransport.includes(modesOfTransport.RAIL) && !timeDisabled}
        peekNextMonth
        showMonthDropdown
        disabled={isDisabled}
        timeFormat={"hh:mm a"}
        timeIntervals={15}
        timeCaption={"time"}
        dateFormat={dateFormat || (!modeoftransport.includes('MULTIMODAL') && !modeoftransport.includes('HIGHWAY') && !modeoftransport.includes(modesOfTransport.TRUCK) && !modeoftransport.includes(modesOfTransport.RAIL) && !timeDisabled) ? "MM/dd/yyyy h:mm aa" : "MM/dd/yyyy"}
        dropdownMode={"select"}
        onMouseDown={(e) => {
          mixPanelMouseDown(e);
        }}
        onMouseEnter={(e) => {
          mixPanelMouseEnter(e);
        }}
        onMouseLeave={(e) => {
          mixPanelMouseLeave(e);
        }}
        isClearable={isClearable}
      />
    </div>
  );
};

export default KNDatePicker;
